
    if (import.meta.env.VITE_IS_EDITOR !== 'true') {
      const script = document.createElement('script');
      script.setAttribute('defer', '');
      script.src = 'https://cloud.umami.is/script.js';
      script.setAttribute('data-website-id', '3557088e-3583-4083-afb7-da93a0889c54');
      document.head.appendChild(script);
    }
  